module.exports = __webpack_public_path__ + "img/home_bg_replace.fa007e2a.jpg";